import ENV_VARS from '../../config';

const useConfig = () => ({
  env: process.env.GATSBY_ENVIRONMENT,
  config: ENV_VARS[process.env.GATSBY_ENVIRONMENT],
});

export default useConfig;
